import { useTranslation } from "next-i18next";
import { IKeyFigureGroup } from "src/api/server/extended-search";
import { FilterCategoryItem } from "src/components/pages/search/components/filter-section/filter-category-item";
import { KeyFiguresGroup } from "src/components/pages/search/components/key-figures-filter/components/key-figures-group";
import { ISearch } from "src/components/pages/search/search.types";

interface IKeyFiguresFilter extends ISearch {
    keyFiguresGroups: ReadonlyArray<IKeyFigureGroup>;
    numberOfSelectedKeyFigures: number;
}

export const KeyFiguresFilter = ({ keyFiguresGroups, numberOfSelectedKeyFigures, onSearch }: IKeyFiguresFilter) => {
    const { t } = useTranslation("extended-search");
    const totalNumberOfKeyFigures = keyFiguresGroups.reduce((acc, keyFigureGroup) => acc + keyFigureGroup.keyFigures.length, 0);

    return (
        <FilterCategoryItem title={t("key-figures")} badgeInfo={`${numberOfSelectedKeyFigures} / ${totalNumberOfKeyFigures}`}>
            {keyFiguresGroups.map(keyFiguresGroup => (
                <KeyFiguresGroup key={keyFiguresGroup.headline} keyFiguresGroup={keyFiguresGroup} onSearch={onSearch} />
            ))}
        </FilterCategoryItem>
    );
};
